var pym = require("./lib/pym");
require("./lib/webfonts");

var pymChild;
var renderD3Graphic = require("./renderD3Graphic");



// Initialize the graphic.
var onWindowLoaded = function() {
  // you would format data here if you needed to
  // var data = formatData(window.DATA);
  render();

  window.addEventListener("resize", () => render());

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

var render = function() {

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

const prevBtn = document.getElementById('prevBtn');
const nextBtn = document.getElementById('nextBtn');
const container = document.getElementById('table-container');
const dotsContainer = document.getElementById('dots-container');
const items = container.querySelectorAll('div');

prevBtn.addEventListener('click', () => {
  container.scrollBy({ left: -container.offsetWidth, behavior: 'smooth' });
});

nextBtn.addEventListener('click', () => {
  container.scrollBy({ left: container.offsetWidth, behavior: 'smooth' });
});

function updateDots() {
  dotsContainer.innerHTML = '';
  
  const containerWidth = container.offsetWidth;
  // This is the total distance the container can actually move
  const maxScrollableWidth = container.scrollWidth - containerWidth;
  
  // If there's nothing to scroll, we don't need dots at all
  if (maxScrollableWidth <= 0) return;

  // Calculate how many items are visible at once
  const itemsPerView = Math.round(containerWidth / container.querySelector('div').offsetWidth);
  
  // Calculate dots based on "steps"
  const totalDots = Math.ceil(items.length / itemsPerView);

  for (let i = 0; i < totalDots; i++) {
    const dot = document.createElement('div');
    dot.classList.add('dot');
    if (i === 0) dot.classList.add('active');
    
    dot.addEventListener('click', () => {
      // Calculate target: either one full "page" or the absolute end
      let targetScroll = i * containerWidth;
      
      // Prevent scrolling past the actual content (the "Extra Dot" fix)
      if (targetScroll > maxScrollableWidth) {
        targetScroll = maxScrollableWidth;
      }

      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    });
    dotsContainer.appendChild(dot);
  }
}

// Update the "active" dot based on scroll position
container.addEventListener('scroll', () => {
  const pageIndex = Math.ceil(container.scrollLeft / container.offsetWidth);
  const dots = document.querySelectorAll('.dot');
  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === pageIndex);
  });
});

// Re-calculate dots when the window changes size (Mobile vs Desktop)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  const dots = document.querySelectorAll('.dot');
  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === 0);
  });
  container.scrollLeft = 0;
  resizeTimer = setTimeout(updateDots, 200); // Debounce to improve performance
});

// Initial call
updateDots();

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);